module.exports = __webpack_public_path__ + "first-10-ir.jpg?a10d6908ca1378e08ac9207e2493a7a2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-10-ir.jpg
// module id = 402
// module chunks = 0